export const NAME = 'kyc';

export const REQUEST_KYC_INITIALIZE = 'REQUEST_KYC_INITIALIZE';
export const SUCCESS_KYC_INITIALIZE = 'SUCCESS_KYC_INITIALIZE';
export const FAILURE_KYC_INITIALIZE = 'FAILURE_KYC_INITIALIZE';

export const REQUEST_KYC_STATE = 'REQUEST_KYC_STATE';
export const SUCCESS_KYC_STATE = 'SUCCESS_KYC_STATE';
export const FAILURE_KYC_STATE = 'FAILURE_KYC_STATE';

export const KYC_STATE_WAITING = 'WAITING';
export const KYC_STATE_VALIDATED = 'VALIDATED';
export const KYC_STATE_DECLINED = 'DECLINED';
export const KYC_STATE_RETRY = 'RETRY';

export const RESET_KYC_STATE = 'RESET_KYC_STATE';

// KYC Modal constants
export const KYC_MODAL_STEP_INIT = 1;
export const KYC_MODAL_STEP_IN_PROGRESS = 2;
export const KYC_MODAL_STEP_ERROR = 3;

export const KYC_MODAL_ERROR_MISSING_DATA = 1;
export const KYC_MODAL_ERROR_FAILED = 2;

export const KYC_USE_CASE_DECLINED_PURCHASE = 'DECLINED_PURCHASE';
export const KYC_USE_CASE_FAILURE_BANK_TRANSFER = 'FAILURE_BANK_TRANSFER';
export const KYC_USE_CASE_WAITING_TRANSACTION = 'WAITING_TRANSACTION';



// WEBPACK FOOTER //
// ./src/services/kyc/constants.js